import { CidadaoCardModel } from 'view/cadastro-imovel/model-cadastroImovel'

import { CidadaoTerritorioBasicoWithProntuarioId, ImovelHeaderDto } from './model-visualizacao-imovel'

export const convertCidadaoTerritorioToCidadaoCard = (
  cidadaoTerritorio: CidadaoTerritorioBasicoWithProntuarioId
): CidadaoCardModel => {
  return {
    id: cidadaoTerritorio.id,
    nome: cidadaoTerritorio.nome,
    nomeSocial: cidadaoTerritorio.nomeSocial,
    dataNascimento: cidadaoTerritorio.dataNascimento,
    sexo: cidadaoTerritorio.sexo,
    cns: cidadaoTerritorio.cns,
    cpf: cidadaoTerritorio.cpf,
    isNovoCadastroNaFamilia: false,
    registroObito: null,
    mudouSe: null,
    grauParentescoResponsavelFamiliar: cidadaoTerritorio.cidadaoNucleoFamiliar?.grauParentescoResponsavelFamiliar,
    telefoneCelular: cidadaoTerritorio.telefoneCelular ?? undefined,
    telefoneContato: cidadaoTerritorio.telefoneContato ?? undefined,
    telefoneResidencial: undefined,
  }
}

export const convertImovelDtoToImovelHeaderDto = (imovel): ImovelHeaderDto => {
  return {
    aldeia: imovel.aldeia,
    bairro: imovel.bairro,
    cep: imovel.cep,
    complemento: imovel.complemento,
    condicoesMoradia: imovel.condicoesMoradia,
    dsei: imovel.dsei,
    latitude: imovel.latitude,
    logradouro: imovel.logradouro,
    longitude: imovel.longitude,
    microarea: imovel.microarea,
    nomeMunicipio: imovel.municipio?.nome,
    nomeTipoLogradouro: imovel.tipoLogradouro?.nome,
    numero: imovel.numero,
    numeroResidenciaIndigena: imovel.numeroResidenciaIndigena,
    poloBase: imovel.poloBase,
    siglaUfMunicipio: imovel.municipio?.uf.sigla,
    telefoneContato: imovel.telefoneContato,
    telefoneResidencial: imovel.telefoneResidencial,
    tipoEndereco: imovel.tipoEndereco,
    tipoImovel: imovel.tipoImovel,
  }
}
